import { render } from "./MainLayout.vue?vue&type=template&id=877e00be&scoped=true&ts=true"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"

import "./MainLayout.vue?vue&type=style&index=0&id=877e00be&scoped=true&lang=css"
import "./MainLayout.vue?vue&type=style&index=1&id=877e00be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-877e00be"],['__file',"src/layouts/master/MainLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "877e00be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('877e00be', __exports__)) {
    api.reload('877e00be', __exports__)
  }
  
  module.hot.accept("./MainLayout.vue?vue&type=template&id=877e00be&scoped=true&ts=true", () => {
    api.rerender('877e00be', render)
  })

}


export default __exports__